import { ISingleDayMetric } from "./Metric";
import moment from "moment";

export enum CosmicSourceTypeEnum {
    PartnerView,
    PlatformMetrics,
    CrossChargeDetails
}
export const CosmicPartnerServiceDetailsColumnNames: (keyof ICosmicServiceDetails)[] = [ "serviceName", "date", "serviceId",  "serviceGroupName", "teamGroupName", "workload", "namespace", "region", "ring", "nodeOS", "containerCount", "cpuUsageCores", "cpuRequestCores", "cpuLimitCores", "cpuUtilizationP99", "memoryWorkingSetMB", "memoryRequestMB", "memoryLimitMB", "memoryUtilizationP99", "rightsizing", "vmFamily"];

export const CosmicPartnerServiceDetailsColumnNames_AppCoreV2: (keyof ICosmicServiceDetails)[] = [ "serviceName", "date", "serviceId",  "serviceGroupName", "teamGroupName", "workload", "namespace", "region", "ring", "nodeOS", "containerCount", "cpuUsageCores", "appCores", "cpuRequestCores", "cpuLimitCores", "cpuUtilizationP99", "memoryWorkingSetMB", "memoryRequestMB", "memoryLimitMB", "memoryUtilizationP99", "rightsizing", "vmFamily"];

export interface ICosmicDailyMetricsByWorkload {
    extractionDate: moment.Moment;
    workload: string;
    cpuUsage: number;
    cpuRequestCores: number;
}

export interface ICosmicDailyMetrics {
    extractionDate: moment.Moment;
    cost: number;
}

// partnerView hierarchical: metric -> workload -> data
export interface ICosmicHierarchicalMetricReport {
    metric: string;
    data: ICosmicHierarchicalWorkloadReport[];
    total?: number;
}

export interface ICosmicHierarchicalWorkloadReport {
    workload: string;
    data: ISingleDayMetric[];
}

// Hierarchical: metric -> legend -> data
export interface ICosmicMetricReport {
    metric: string;
    data: ICosmicMetric[];
    total?: number;
}

export interface ICosmicMetric {
    legend: string;
    data: ISingleDayMetric[];
}

// Cosmic service details in partnerView
export interface ICosmicServiceDetails {
    date: moment.Moment;
    workload: string;
    teamGroupName: string;
    serviceGroupName: string;
    serviceName: string;
    serviceId: string;
    namespace: string;
    region: string;
    ring: string;
    nodeOS: string;
    containerCount: number;
    cpuUsageCores: number;
    appCores: number;
    cpuRequestCores: number;
    cpuLimitCores: number;
    cpuUtilizationP99: number;
    memoryWorkingSetMB: number;
    memoryRequestMB: number;
    memoryLimitMB: number;
    memoryUtilizationP99: number;
    rightsizing: number;
    vmFamily: string;
}

export interface ICosmicServiceDetailReport<D extends ICosmicServiceDetails = ICosmicServiceDetails> {
    total: Partial<D>;
    max: Partial<D>;
    min: Partial<D>;
    data: D[];
    rowCount: number,
}

export interface CosmicCostNode {
    id: string;
    name: string;
    level: number;
    children: CosmicCostNode[];
    hasChildren: string;
    parent?: string;
    cost: number;
}

export interface CosmicCostHierarchyResponse {
    data: CosmicCostNode[];
    totalCost: number;
    // month: string;
}

export interface CosmicCostAndCoreNode {
    id: string;
    name: string;
    level: number;
    children: CosmicCostAndCoreNode[];
    hasChildren: string;
    parent?: string;
    cost: number;
    appCores: number;
    fragmentationCores: number;
    emptyAppCores: number;
    totalCores: number;
    pricePerCore: number;
}

export interface CosmicCostAndCoreHierarchyResponse {
    data: CosmicCostAndCoreNode[];
    totalCost: number;
    totalAppCores: number;
    totalFragmentationCores: number;
    totalEmptyAppCores: number;
    totalCores: number;
    totalPricePerCore: number;
    // month: string;
}

// export interface CosmicMonthlyCostByCategory {
//     category: string;
//     data: ISingleDayMetric[];
// }

// export interface CosmicMonthlyCostByCategoryResponse {
//     workload: string;
//     data: CosmicMonthlyCostByCategory[];
// }
